import { useState, useEffect } from 'react';

const useIsTablet = (breakpoint = 1360) => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkIsTablet = () => {
      setIsTablet(window.innerWidth <= breakpoint);
    };

    // Check on mount
    checkIsTablet();

    // Add event listener
    window.addEventListener('resize', checkIsTablet);

    // Cleanup
    return () => window.removeEventListener('resize', checkIsTablet);
  }, [breakpoint]);

  return isTablet;
};

export default useIsTablet;